import React from "react";
import { Button } from "semantic-ui-react";
import ValidatorContext from "../../../formvalidation/FormContext";
import { routes } from "utilities/routing/generatedRoutes";
import { useValidators } from "formvalidation/hooks";
import DoublePasswordInput from "components/ValidatedFields/WithErrorLabel/DoublePasswordInput";
import CurrentPasswordInput from "components/ValidatedFields/WithErrorLabel/CurrentPasswordInput";

const ChangePasswordPanel = () => {
  const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);
  const [currentPassword, setCurrentPassword] = React.useState<string>("");
  const [newPassword1, setNewPassword1] = React.useState<string>("");
  const [newPassword2, setNewPassword2] = React.useState<string>("");

  const validators = useValidators();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true);
    const validationResult = await validators.validateAll();
    if (validationResult.hasErrors) {
      setIsSubmitting(false);
      return;
    }

    await window.CoreApi.Account.ChangeMyPassword({
      oldPassword: currentPassword,
      newPassword: newPassword1
    });

    window.location.href = routes.personal_SettingMenu().absolute;
  };
  return (
    <ValidatorContext settings={validators.validatorSettings}>
      <table className="s1_table clean rowspace">
        <tbody>
          <tr>
            <td>{RESX.PersonalSettings.CurrentPassword} </td>
            <td>
              <CurrentPasswordInput
                validatorKey="currentpassword"
                value={currentPassword}
                onChange={setCurrentPassword}
              /></td>
          </tr>
          <tr>
            <td>{RESX.PersonalSettings.NewPassword}</td>
            <td><DoublePasswordInput.FirstPasswordInput
              validatorKey="newpassword"
              value={newPassword1}
              onChange={setNewPassword1}
            /></td>
          </tr>
          <tr>
            <td>{RESX.PersonalSettings.RetypePassword}</td>
            <td>
              <DoublePasswordInput.SecondPasswordInput
                validatorKey="verifypassword"
                value={newPassword2}
                firstPassword={newPassword1}
                onChange={setNewPassword2}
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div className="flex margin-top-bigger">
        <div className="grow1"></div>
        <Button onClick={onSubmit} loading={isSubmitting} primary>{RESX.Buttons.btnSave}</Button>
      </div>
    </ValidatorContext>
  );
};

export default ChangePasswordPanel;